import dev from './dev'
import prod from './prod'
import extention from './extention'

import _ from 'lodash'
const NODE_ENV = process.env.NODE_ENV || 'staging';

let config = _.merge(dev);

if(NODE_ENV === 'production'){
  config = _.merge(config, prod)
}

config = _.merge(config, extention);

export default config;


// WEBPACK FOOTER //
// ./src/config/index.js